// src/controllers/atributoController.js

import { getAtributos, createAtributo, updateAtributo, deleteAtributo } from '../models/atributoModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

// Obtener lista de atributos paginados
export async function fetchAtributos(page, perPage) {
  try {
    const response = await getAtributos(page, perPage);
    return {
      atributo: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching atributos:", error);
    Swal.fire('Error', 'No se pudieron cargar los atributos', 'error');
    return null;
  }
}

// Guardar o actualizar un atributo
export async function saveAtributo(atributo, currentAtributoId) {
  try {
    if (currentAtributoId) {
      await updateAtributo(currentAtributoId, atributo);
      toasts.add({
        title: 'Éxito',
        description: 'Atributo guardado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createAtributo(atributo);
      toasts.add({
        title: 'Éxito',
        description: 'Atributo creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving atributo:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el atributo',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

// Eliminar un atributo
export async function removeAtributo(id) {
  try {
    await deleteAtributo(id);
    toasts.add({
      title: 'Éxito',
      description: 'Atributo eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting atributo:", error);
    Swal.fire('Error', 'No se pudo eliminar el atributo', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'atributo'
export function subscribeToAtributos(searchQuery, handleSearch) {
  pb.collection('atributo').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromAtributos() {
  pb.collection('atributo').unsubscribe('*');
}

// Buscar atributos por descripción con paginación
export async function searchAtributos(query, page = 1, perPage = 10) {
  const response = await pb.collection('atributo').getList(page, perPage, {
    filter: `descrip ~ "${query}"`,
  });
  return {
    atributo: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}
